import { createEvent } from 'effector'
import { QueryCacheNotifyEvent } from '@tanstack/react-query'
import { queryClient } from '../query-client'

class QueryCacheService {
  readonly queryCacheEvent = createEvent<QueryCacheNotifyEvent>()

  subscribe = (): VoidFunction => {
    const unsubscribeEvent = queryClient.getQueryCache().subscribe((event) => {
      this.queryCacheEvent(event)
    })

    return (): void => {
      unsubscribeEvent()
    }
  }
}

export const queryCacheService = new QueryCacheService()
